import React from 'react'

function FormHeaderLabel(props) {
  return (
    <>
      <h1 className='opk-login-title' style={{ fontSize: props.fs, textAlign: 'center' }}>{props.UpperText}</h1>
      <p className='opk-login-subtitle' style={{ textAlign: 'center' }}>{props.LowerText}</p>
    </>
  )
}

export default FormHeaderLabel